<template>
  <div class="application-modal ordernumber-modal">
    <div class="application-modal__window">

      <div class="small-modal">
        <div class="small-modal__title">
          {{title}}
        </div>

        {{content}}

        <div class="small-modal__cta">
          <button
            id="application-send"
            class="btn btn--large"
            :class="`btn--${color}`"
          >
            {{send}}
          </button>
          <button
            id="application-cancel"
            class="btn btn--large"
            :class="`btn--${color}`"
          >
            {{cancel}}
          </button>
       </div>
      </div>

    </div>
  </div>
</template>


<script>
  export default {
    props: {
      color: {
        type: String,
        default: 'default',
      },
      title: {
        type: String,
        default: 'Puuttuva järjestysnumero',
      },
      content: {
        type: String,
        default: 'Hakemuslomakkeen kunnalta puuttuu järjestysnumero etkä saa tarjousta asunnosta ennen kuin se on tallennettu hakemuslomakkeelle. Voit täydentää hakemustasi myös myöhemmin. Haluatko lähettää hakemuksesi jo nyt eteenpäin ilman järjestysnumeroa?',
      },
      send: {
        type: String,
        default: 'Lähetä',
      },
      cancel: {
        type: String,
        default: 'Älä lähetä',
      },
    },
  }
 </script>

 <style lang="scss">
  @import "~styles/definitions";

  .ordernumber-modal {
    display: none;

    &.visible {
      display: initial;
    }

    .btn {
      margin: 0.5em;

      @include media-breakpoint-up(md) {
        width: 8em;
      }
    }
  }  
 </style>
